// extracted by mini-css-extract-plugin
export default {"image":"q3-z","loaded":"r3-z"};